import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IDroneAreas } from 'src/models/drone-areas.model';
import services from 'src/services/drone-areas.services';

export const actionTypes = {
  DRONE_AREAS_FETCH: 'DRONE_AREAS_FETCH',
  DRONE_AREAS_ADD: 'DRONE_AREAS_ADD',
  DRONE_AREAS_UPDATE: 'DRONE_AREAS_UPDATE',
  DRONE_AREAS_DELETE: 'DRONE_AREAS_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.DRONE_AREAS_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.DRONE_AREAS_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.DRONE_AREAS_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.DRONE_AREAS_DELETE,
    service: services.itemDELETE,
  },
};

export type IDroneAreasAsync = typeof asyncActions;

export interface IDroneAreasState extends ICommonState<IDroneAreasAsync> {
  data?: IDroneAreas;
  list: IDroneAreas[];
  total: number;
}

export const defaultState: IDroneAreasState = {
  status: {},
  list: [],
  total: 0,
};

const DroneAreasReducer = (
  state: IDroneAreasState = defaultState,
  action: IReducerAction<IDroneAreasAsync>
): IDroneAreasState => {
  switch (action.type) {
    case actionTypes.DRONE_AREAS_FETCH: {
      return {
        ...state,
        list: action.payload?.droneAreas.rows ?? [],
        total: action.payload?.droneAreas.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default DroneAreasReducer;
